export default __webpack_public_path__ + "static/media/mirage.d316322b.jpeg";